<link [href]="this.url | safe" rel="stylesheet">

<ion-app>
  @if (this.auth.isAuthenticated() == true) {
    <ion-menu contentId="main-content" type="overlay">
      <app-sidebar></app-sidebar>
    </ion-menu>
  }
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>

<!-- TEST SONAR -->